import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { ContentMessage } from 'axway-react-ui';
import IntlComponent from 'axway-react-intl';

class UninstallConfirmView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.intl.formatMsg('APIs from Models are auto-generated with this plugin. They will not be available after uninstallation. The affected connector instances are: {connectors}. Are you sure you want to uninstall?', 'plugin_in_use');
	}

	render() {
		// connectionsWithModelAutogen is either null or array that holds connector instances names
		const connectorsWithModelAutogen = this.props.connectorsWithModelAutogen;

		// check the length just in case to not break on contract change
		const summary = (connectorsWithModelAutogen && connectorsWithModelAutogen.length > 0)
			? this.intl.formatMsg({ id: 'plugin_in_use' }, { connectors: connectorsWithModelAutogen.join(', ') })
			: this.intl.formatMsg('Are you sure you want to uninstall?');
		return (
			<ContentMessage
				confirm
				actionClass="btn-primary"
				onClose={this.props.cancelUninstallRequest}
				summary={summary}
				className="lg warning"
				imgClass="gg icon-GG-warning"
				onAction={this.props.uninstallComponent}
				actionLabel={this.intl.formatMsg('Proceed')}
				cancelLabel={this.intl.formatMsg('Cancel')}
			/>
		);
	}
}

UninstallConfirmView.propTypes = {
	uninstallComponent: PropTypes.func.isRequired,
	cancelUninstallRequest: PropTypes.func.isRequired,
	connectorsWithModelAutogen: PropTypes.array
};

export default injectIntl(UninstallConfirmView);
